import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
} from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const CardSkeleton = () => (
  <Card className="grow min-h-[420px]">
    <CardHeader>
      <Skeleton className="h-6 w-[340px] mb-2" />
    </CardHeader>
    <CardDescription className="px-6">
      <Skeleton className="h-4 w-[600px] mb-2" />
      <Skeleton className="h-4 w-[200px] mb-2" />
      <Skeleton className="h-4 w-[450px] mb-2" />
      <Skeleton className="h-4 w-[150px] mb-2" />
    </CardDescription>
    <CardContent className="px-6">
      <div className="grid gap-4">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} className="h-4 w-full" />
        ))}
      </div>
      <Skeleton className="h-4 w-[150px] mt-4" />
    </CardContent>
  </Card>
)
